import { docReady } from './doc-ready';
import { breakPoints } from './breakPoints';
const breakPoint = breakPoints.tabletportrait;
const switchMedia = (instance, desktopVideo, mobileVideo) => {
    if (window.innerWidth < breakPoint) {
        if (mobileVideo && instance.src !== mobileVideo) {
            instance.src = mobileVideo;
        }
    }
    else {
        if (desktopVideo && instance.src !== desktopVideo) {
            instance.src = desktopVideo;
        }
        if (mobileVideo && instance.src == mobileVideo) {
            instance.removeAttribute('src');
            instance.load();
        }
    }
};
const init = () => {
    Array.from(document.querySelectorAll('[data-video-observer]')).map((instance) => {
        var _a, _b;
        const desktopVideo = ((_a = instance.attributes['data-src-desktop']) === null || _a === void 0 ? void 0 : _a.value) || null;
        const mobileVideo = ((_b = instance.attributes['data-src-mobile']) === null || _b === void 0 ? void 0 : _b.value) || null;
        const threshold = 0;
        let isPaused = false;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !instance.src) {
                    if (window.innerWidth < breakPoint && mobileVideo) {
                        instance.src = mobileVideo;
                    }
                    else if (desktopVideo) {
                        if (window.innerWidth < breakPoint) {
                            instance.src = null;
                            instance.removeAttribute('src');
                        }
                        else {
                            instance.src = desktopVideo;
                        }
                    }
                    window.addEventListener('resize', () => {
                        switchMedia(instance, desktopVideo, mobileVideo);
                    });
                }
                if (entry.intersectionRatio < threshold) {
                    instance.pause();
                    isPaused = true;
                }
                else if (isPaused) {
                    instance.play().catch((error) => {
                        if (error.name === 'NotAllowedError') {
                            instance.style.display = 'none';
                        }
                    });
                    isPaused = false;
                }
            });
        }, {
            root: null,
            rootMargin: '20px',
            threshold: threshold,
        });
        observer.observe(instance);
    });
};
docReady(() => {
    init();
});
